import { useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useToast } from '@/hooks/use-toast';

interface TagMappingResult {
  success: boolean;
  message: string;
  licenseAssigned?: string;
  tagsFound?: string[];
  error?: string;
}

export const useKeapTagMapping = () => {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const performTagMapping = async (): Promise<TagMappingResult> => {
    setLoading(true);
    try {
      const { data, error } = await supabase.functions.invoke('keap-tag-mapping');
      
      if (error) {
        console.error('Tag mapping error:', error);
        throw new Error(error.message || 'Tag mapping failed');
      }

      const result = data as TagMappingResult;
      
      if (!result.success) {
        throw new Error(result.message || 'Tag mapping failed');
      }

      console.log('Tag mapping successful:', result);
      return result;
      
    } catch (error) {
      console.error('Error during tag mapping:', error);
      const errorResult: TagMappingResult = {
        success: false,
        message: error.message || 'Your subscription could not be verified. Please contact support if you believe this is a mistake.',
        error: error.message
      };
      
      // Only show toast if this is an actual authentication/subscription issue
      // Skip toast for configuration issues to prevent spam
      if (error.message && !error.message.includes('not authenticated') && !error.message.includes('email not available')) {
        toast({
          title: "Subscription Verification Failed",
          description: errorResult.message,
          variant: "destructive",
        });
      }
      
      return errorResult;
    } finally {
      setLoading(false);
    }
  };

  return {
    performTagMapping,
    loading
  };
};